import { Box } from "@repo/components/src/ui/box";
import { Text } from "@repo/components/src/ui/text";
import { VStack } from "@repo/components/src/ui/vstack";
import { ProductsSelectionQuery } from "@repo/graphql/documents/product/query.generated";
import { CampaignObject } from "@repo/graphql/gql/graphql";
import React from "react";
import ProductCard from "./ProductCard";
import SectionHeader from "./SectionHeader";
import type { SectionStatus } from "./sectionStatus";

type ProductNode =
  ProductsSelectionQuery["product"]["list"]["edges"][number]["node"];

type Props = {
  object: string | null;
  productIds: string[];
  products: Map<string, ProductNode>;
  status: SectionStatus;
};

const EmptyState = ({ children }: { children: string }) => (
  <Box className="rounded-3xl bg-white border border-outline-100 px-4 py-4">
    <Text size="sm" action="muted">
      {children}
    </Text>
  </Box>
);

/** Ported from `apps/mobil/.../about/ProductsCard.tsx`. */
const ProductsSection = React.memo(
  ({ object, productIds, products, status }: Props) => {
    let body;
    if (object === CampaignObject.Brand) {
      body = (
        <EmptyState>
          La campaña está dirigida a promocionar la imagen de marca.
        </EmptyState>
      );
    } else if (object === CampaignObject.Event) {
      body = (
        <EmptyState>
          La campaña está dirigida a promocionar un evento.
        </EmptyState>
      );
    } else if (productIds.length === 0) {
      body = <EmptyState>Aún no se han definido productos.</EmptyState>;
    } else {
      body = (
        <VStack space="sm">
          {productIds.map((productId, index) => {
            const product = products.get(productId);
            return product ? (
              <ProductCard key={productId} product={product} index={index} />
            ) : null;
          })}
        </VStack>
      );
    }

    return (
      <>
        <SectionHeader
          title="Productos o servicios a promocionar"
          status={status}
        />
        {body}
      </>
    );
  },
);

ProductsSection.displayName = "ProductsSection";

export default ProductsSection;
